:host(:focus),
:host(:focus-visible) {
    outline: none;
}
:host{
    --border-color:var(--jb-input-border-color, #f7f6f6);
    --message-color:var(--jb-input-message-color, #929292);
}
:host(:state(invalid)){
    --message-color:var(--jb-input-message-error-color, red);
}
:host(:focus-within){
    --border-color:var(--jb-input-border-color-focus, #1e2832);
}
.jb-input-web-component {
    width: 100%;
    margin: var(--jb-input-margin, 0 0);
    &:focus-visible {
        outline: none;
    }
    label {
        width: 100%;
        margin: var(--jb-input-label-margin, 4px 0px);
        display: block;
        font-size: var(--jb-input-label-font-size, 0.8em);
        color: var(--jb-input-label-color, #1f1735);
        margin: var(--jb-input-label-margin, 0);
        font-weight: var(--jb-input-label-font-weight, 300);
        &.--hide {
            display: none;
        }
    }

    .input-box {
        width: 100%;
        box-sizing: border-box;
        height: var(--jb-input-height, 40px);
        border: solid var(--jb-input-border-width, 1px) var(--border-color);
        background-color: var(--jb-input-bgcolor, #f7f6f6);
        border-bottom: solid var(--jb-input-border-bottom-width, 3px) var(--border-color);
        border-radius: var(--jb-input-border-radius, 16px);
        margin: 4px 0px;
        transition: ease 0.3s all;
        overflow: var(--jb-input-box-overflow, hidden);
        display: grid;
        grid-template-columns: auto 1fr auto;
        box-shadow: var(--jb-input-box-shadow, none);
        &:focus-within {
            border-width: var(--jb-input-border-width-focus, var(--jb-input-border-width, 1px));
            border-bottom-width: var(--jb-input-border-bottom-width-focus, var(--jb-input-border-bottom-width, 3px));
            box-shadow: var(--jb-input-box-shadow-focus, none);
        }
        input {
            border: none;
            width: 100%;
            box-sizing: border-box;
            height: 100%;
            background-color: transparent;
            padding: var(--jb-input-input-padding, 2px 12px 0 12px);
            display: block;
            font-family: inherit;
            font-size: var(--jb-input-value-font-size, 1.1rem);
            color: var(--jb-input-value-color, #1f1735);
            margin: 0;
            border-radius: 0;
            text-align: var(--jb-input-input-text-align, initial);
            direction: var(--jb-input-input-direction, inherit);
            font-weight: var(--jb-input-input-font-weight, initial);
            &:focus {
                outline: none;
            }
            &::placeholder {
                color: var(--jb-input-placeholder-color, initial);
                font-size: var(--jb-input-placeholder-font-size, 1.1rem);
            }
            //remove number input arrow keys of browser
            /* Chrome, Safari, Edge, Opera */
            &::-webkit-outer-spin-button,
            &::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }

            /* Firefox */
            &[type="number"] {
                -moz-appearance: textfield;
            }
        }
        .jb-input-start-section-wrapper{
            display: flex;
            height: 100%;
            width: auto;
            align-items: center;
            justify-content: center;
        }
        ::slotted([slot="start-section"]), ::slotted([slot="end-section"]){
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            max-height: 100%;
            overflow-y: hidden;
            background-color: transparent;
            padding: 8px 16px;
            width: auto;
            box-sizing: border-box;
        }
    }
    .message-box {
        font-size: var(--jb-input-message-font-size, 0.7rem);
        padding: 2px 8px;
        color: var(--message-color);
        display: var(--jb-input-message-box-display, block);
        &:empty {
            padding: 0;
        }
    }
}
